"use client"

import { jsxs as f, jsx as a } from "react/jsx-runtime";
import { createContext as U, useContext as S, useState as w, useEffect as I, useRef as M, useCallback as V, forwardRef as Y, useMemo as T, useImperativeHandle as Z } from "react";
import { createPortal as J } from "react-dom";
function Q(t) {
  const e = ee(t);
  return function() {
    const n = e[0] ^ e[0] << 11;
    return e[0] = e[1], e[1] = e[2], e[2] = e[3], e[3] = e[3] ^ e[3] >> 19 ^ n ^ n >> 8, (e[3] >>> 0) / (1 << 31 >>> 0);
  };
}
function ee(t) {
  const e = new Uint32Array([0, 0, 0, 0]);
  for (let n = 0; n < t.length; n++)
    e[n % 4] = (e[n % 4] << 5) - e[n % 4] + t.charCodeAt(n);
  return e;
}
function te(t) {
  const e = N(t), n = N(t), o = N(t);
  return [n, e, o];
}
function N(t) {
  return new Uint16Array([
    // hue = 0 to 360 (whole color spectrum)
    t() * 360,
    // saturation = 40 to 100 (avoid greyish colors)
    40 + t() * 60,
    // lightness = 0 to 100 but probabilities are a bell curve around 50%
    (t() + t() + t() + t()) * 25
  ]);
}
const ne = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" shape-rendering="optimizeSpeed" ';
function oe(t, e) {
  const n = Q(t.toLowerCase()), [o, r, s] = te(n), c = [
    "M0,0H8V8H0z",
    // background
    "",
    // color
    ""
    // spot
  ];
  for (let l = 0, d, i; l < 32; l++) {
    d = l % 4, i = Math.floor(l / 4);
    const p = Math.floor(n() * 2.3);
    p > 0 && (c[p] += `M${d},${i}h1v1h-1zM${7 - d},${i}h1v1h-1z`);
  }
  return `${ne}width="${e}" height="${e}"><path fill="hsl(${o[0]} ${o[1]}% ${o[2]}%)" d="${c[0]}"/><path fill="hsl(${r[0]} ${r[1]}% ${r[2]}%)" d="${c[1]}"/><path fill="hsl(${s[0]} ${s[1]}% ${s[2]}%)" d="${c[2]}"/></svg>`;
}
function z(t, e = 64) {
  return "data:image/svg+xml;base64," + btoa(ie(t, e));
}
function ie(t, e = 64) {
  return oe(t, e);
}
var ae = "_1uctt8h1 _1izal310", re = "_1uctt8h2", se = "_1uctt8h4", le = "_1uctt8h3", ce = "_1uctt8h5", de = "_1izal311", ue = "_1uctt8h0";
const C = {
  // general
  textColor: "#1E1E1E",
  secondaryColor: "#808080",
  focusColor: "#1E1E1E",
  fontSize: 15,
  // badge
  badgeBackground: "#ededed",
  badgeGap: 3,
  badgeHeight: 24,
  badgePadding: 0,
  badgeLabelPadding: 8,
  badgeRadius: 4,
  // popup
  popupBackground: "#fff",
  popupRadius: 4,
  popupShadow: "0 4px 8px rgb(0 0 0 / 0.1)"
}, B = {
  ...C,
  textColor: "#D9D9D9",
  secondaryColor: "#808080",
  focusColor: "#D9D9D9",
  badgeBackground: "#1E1E1E",
  popupBackground: "#1E1E1E"
}, H = {
  badgeHeight: 32,
  badgePadding: 4,
  badgeLabelPadding: 6,
  badgeGap: 0,
  badgeBackground: "none",
  badgeRadius: 32
}, L = {
  badgeBackground: "none",
  badgeGap: 0,
  badgeLabelPadding: 4,
  badgeIconRadius: 12
}, pe = "light", j = {
  light: C,
  dark: B,
  "unified-light": {
    ...C,
    ...H,
    badgeBackground: "#ededed"
  },
  "unified-dark": {
    ...B,
    ...H,
    badgeBackground: "#1E1E1E"
  },
  "simple-light": {
    ...C,
    ...L
  },
  "simple-dark": {
    ...B,
    ...L
  }
};
function he(t = "light") {
  const { base: e, ...n } = typeof t == "string" ? { base: t } : t;
  return {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    ...e && j[e] || j[pe],
    ...n
  };
}
const fe = `._1izal310{border:0;margin:0;padding:0;font:inherit;line-height:inherit;color:inherit;background:none;appearance:none;text-align:left;text-decoration:none;text-transform:none;white-space:nowrap;cursor:pointer}._1izal311{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._1izal312{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%}._1izal313{flex-shrink:0;flex-grow:0;position:relative;width:1.3em;height:1.3em}._1izal314{width:1.6em;height:1.6em}._1izal315{width:100%;height:100%}._1uctt8h0{display:inline-flex}._1uctt8h0 *{box-sizing:border-box}._1uctt8h1{display:grid;grid-auto-flow:column;outline:0}._1uctt8h3{position:relative;z-index:2;overflow:hidden;height:100%;outline-width:2px}._1uctt8h1:focus-visible ._1uctt8h3{outline-style:solid}._1uctt8h4{inset:0;z-index:1;height:100%}._1uctt8h2:active~*,._1uctt8h2:active ._1uctt8h4,._1uctt8h1:active ._1uctt8h3{top:1px}._1uctt8h5{position:relative;z-index:1;overflow:hidden;display:flex;align-items:center;height:100%}._3v7ok30{display:flex;flex-direction:column;gap:1.2em;padding:1.2em 1.2em 1em}._3v7ok31{display:flex;align-items:center;gap:1.2em;width:100%}._3v7ok32{border-radius:.4em;width:3.6em;height:3.6em}._3v7ok33{display:grid;grid-template-columns:repeat(3,1fr);gap:.8em .6em}._3v7ok34{display:flex;justify-content:space-between;gap:1.2em;width:100%}._3v7ok35{flex-shrink:1;flex-grow:1;flex-basis:0;max-width:fit-content}._1op5tvx0{flex-shrink:0;position:relative;z-index:1;display:flex;align-items:center;gap:.3em;border-radius:4px}._1op5tvx0:active{top:1px}._1op5tvx0:focus-visible{z-index:2;outline-offset:0;outline-width:2px;outline-style:solid}._1op5tvx1{position:absolute;inset:0;opacity:0;scale:.5;transition-property:opacity,scale;transition-duration:50ms;transition-timing-function:ease-out}._1op5tvx2{opacity:1;scale:1}._1op5tvx3{transition-property:none}.u42wwe0{flex-shrink:0;overflow:hidden;position:relative;z-index:1;display:flex;align-items:center;justify-content:flex-end;width:0;gap:.3em;text-decoration:none;color:inherit;border-radius:4px}.u42wwe0:active{top:1px}.u42wwe0:focus-visible{z-index:2;outline-offset:0;outline-width:2px;outline-style:solid}.u42wwe1{flex-shrink:1}.cyi06j0{z-index:999;overflow:hidden;outline:0;opacity:0;scale:.9 .9 1;transition-property:opacity,scale;transition-duration:.1s;transition-timing-function:cubic-bezier(0,.5 .5,1);pointer-events:none}.cyi06j0,.cyi06j0 *{box-sizing:border-box}.cyi06j1{opacity:1;scale:1 1 1;pointer-events:auto}.cyi06j2{position:absolute;outline:0}
`, A = U({});
function ge({
  children: t,
  ...e
}) {
  const n = {
    ...S(A),
    ...e
  };
  return /* @__PURE__ */ f(
    A.Provider,
    {
      value: {
        ...n,
        externalCss: !0
        // no need to inject the CSS below
      },
      children: [
        !n.externalCss && /* @__PURE__ */ a("style", { dangerouslySetInnerHTML: { __html: fe } }),
        t
      ]
    }
  );
}
function P(t) {
  return typeof t == "string" ? { fontFamily: t, fontWeight: "400" } : t;
}
function me(t) {
  const e = {
    ...S(A),
    ...t
  }, n = P(e.font ?? "inherit");
  return {
    ...e,
    actions: e.actions ?? "all",
    explorer: e.explorer ?? ((o) => ({
      accountUrl: `https://etherscan.io/address/${o}`,
      name: "Etherscan"
    })),
    font: n,
    fontMono: P(e.fontMono ?? n),
    icon: e.icon ?? (e.ens === !1 ? "identicon" : "ens"),
    label: e.label ?? (e.ens === !1 ? "address" : "ens"),
    shortenAddress: e.shortenAddress ?? 4,
    theme: he(e.theme)
  };
}
var ve = "_3v7ok34", be = "_3v7ok33", xe = "_3v7ok31", ye = "_3v7ok35", we = "_3v7ok32", _e = "_3v7ok30", W = "_1op5tvx1", D = "_1op5tvx2", F = "_1op5tvx3", ke = "_1izal312", Ee = "_1izal313", ze = "_1izal314 _1izal312", Ce = "_1izal315 _1izal313", Me = "_1op5tvx0 _1izal310";
const $e = {
  link: "M27 12.5V5h-7.5M18 14l9-9m-4 13v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h8",
  copy: "M27 23 V5 H9 M23 9 H5 V27 H23 V9 Z",
  check: "M27 9L13 23L6 16"
}, R = ({
  name: t
}) => /* @__PURE__ */ a("div", { style: { display: "grid" }, children: /* @__PURE__ */ a(
  "svg",
  {
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /* @__PURE__ */ a("path", { d: $e[t] })
  }
) });
function O(t, e) {
  const [n, o] = w(t ? "enter" : "from"), [r, s] = w(t);
  return I(function() {
    let l = {};
    return t ? (o("from"), s(!0), l = G(() => {
      o("enter");
    })) : (o("leave"), l = G(() => {
      s(!1);
    }, e)), () => {
      Ne(l);
    };
  }, [t, e]), {
    stage: n,
    shouldMount: r
  };
}
function G(t, e = 0) {
  const n = performance.now(), o = {};
  function r() {
    o.id = requestAnimationFrame((s) => {
      s - n > e ? t() : r();
    });
  }
  return r(), o;
}
function Ne(t) {
  t.id && cancelAnimationFrame(t.id);
}
function q({
  className: t,
  content: e,
  label: n,
  showLabel: o,
  style: r,
  theme: s
}) {
  const [c, l] = w(!1), d = M(), i = V(() => {
    d.current?.(), d.current = () => {
      clearTimeout(g);
    }, l(!0);
    const g = setTimeout(() => {
      l(!1);
    }, 400);
  }, []), p = O(c, 100);
  return n = `Copy ${n}`, /* @__PURE__ */ f(
    "button",
    {
      className: [Me, t ?? ""].join(" "),
      title: n,
      onClick: () => {
        navigator.clipboard.writeText(e), i();
      },
      style: {
        overflow: "hidden",
        color: s.secondaryColor,
        outlineColor: s.focusColor,
        ...r
      },
      children: [
        o && /* @__PURE__ */ a("div", { children: `${n} ` }),
        /* @__PURE__ */ a("div", { className: o ? ze : ke, children: /* @__PURE__ */ f("div", { className: o ? Ce : Ee, children: [
          /* @__PURE__ */ a(
            "div",
            {
              className: [
                W,
                p.stage !== "enter" ? D : "",
                p.stage !== "leave" ? F : ""
              ].join(" "),
              children: /* @__PURE__ */ a(R, { name: "copy" })
            }
          ),
          /* @__PURE__ */ a(
            "div",
            {
              className: [
                W,
                p.stage === "enter" ? D : "",
                p.stage === "leave" ? F : ""
              ].join(" "),
              children: /* @__PURE__ */ a(R, { name: "check" })
            }
          )
        ] }) })
      ]
    }
  );
}
var Be = "_1izal312", Ae = "_1izal313", Re = "u42wwe1 _1izal311", Se = "_1izal314 _1izal312", Ie = "_1izal315 _1izal313", Te = "u42wwe0 _1izal310";
function K({
  className: t,
  explorer: e,
  showLabel: n,
  style: o,
  theme: r
}) {
  return /* @__PURE__ */ f(
    "a",
    {
      className: [Te, t].join(" "),
      href: e.accountUrl,
      title: e.name,
      rel: "noopener noreferrer",
      target: "_blank",
      style: {
        display: "flex",
        color: r.secondaryColor,
        outlineColor: r.focusColor,
        ...o
      },
      children: [
        n && /* @__PURE__ */ a("div", { className: Re, children: e.name + " " }),
        /* @__PURE__ */ a("div", { className: n ? Se : Be, children: /* @__PURE__ */ a("div", { className: n ? Ie : Ae, children: /* @__PURE__ */ a(R, { name: "link" }) }) })
      ]
    }
  );
}
var He = "cyi06j2", Le = "cyi06j0", je = "cyi06j1";
const E = 20;
function Pe({
  children: t,
  onClose: e,
  target: n,
  show: o = !0,
  theme: r
}) {
  const [[s, c], l] = w([0, 0]), d = M(null), { stage: i, shouldMount: p } = O(o, 300), g = p || o, b = M(), m = V(() => {
    b.current?.focus({ preventScroll: !0 }), e?.();
  }, [e]);
  return I(() => {
    if (!d.current || !n || !g || !o)
      return;
    const u = d.current, _ = new ResizeObserver(() => {
      if (!n.current)
        return;
      const h = n.current.getBoundingClientRect(), [k, v] = [
        window.scrollX + Math.max(
          E,
          // min left
          Math.min(
            window.innerWidth - u.offsetWidth - E,
            // max right
            h.x - u.offsetWidth / 2 + h.width / 2
          )
        ),
        window.scrollY + Math.max(
          E,
          // min top
          Math.min(
            window.innerHeight - u.offsetHeight - E,
            // max bottom
            h.y - u.offsetHeight / 2 + h.height / 2
          )
        )
      ];
      l(($) => $[0] === k && $[1] === v ? $ : [k, v]);
    });
    _.observe(u);
    const x = ({ key: h }) => {
      h === "Escape" && m();
    };
    u.ownerDocument.addEventListener("keydown", x), window.addEventListener("resize", m);
    const { activeElement: y } = u.ownerDocument;
    return y instanceof HTMLElement && (b.current ??= y), u.focus({ preventScroll: !0 }), () => {
      _.disconnect(), u.ownerDocument.removeEventListener("keydown", x), window.removeEventListener("resize", m);
    };
  }, [m, g, o, n]), g && /* @__PURE__ */ f(
    "div",
    {
      ref: d,
      className: [
        Le,
        i === "enter" ? je : ""
      ].join(" "),
      onBlur: (u) => {
        d.current?.contains(u.relatedTarget) || (u.stopPropagation(), m());
      },
      tabIndex: 0,
      style: {
        position: n ? "absolute" : "static",
        top: c,
        left: s,
        background: r.popupBackground,
        borderRadius: r.popupRadius,
        boxShadow: r.popupShadow
      },
      children: [
        t,
        /* @__PURE__ */ a(
          "div",
          {
            onFocus: m,
            tabIndex: 0,
            className: He
          }
        )
      ]
    }
  );
}
function We({
  address: t,
  explorer: e,
  onClose: n,
  show: o,
  target: r
}) {
  const { theme: s, ...c } = me();
  return /* @__PURE__ */ a(
    Pe,
    {
      onClose: n,
      target: r,
      show: o,
      theme: s,
      children: /* @__PURE__ */ f(
        "div",
        {
          className: _e,
          style: {
            ...c.font,
            fontSize: s.fontSize
          },
          children: [
            /* @__PURE__ */ f("div", { className: xe, children: [
              /* @__PURE__ */ a(
                "img",
                {
                  className: we,
                  alt: "",
                  src: z(t)
                }
              ),
              /* @__PURE__ */ a(
                "div",
                {
                  className: be,
                  style: {
                    ...c.fontMono,
                    color: s.textColor
                  },
                  // split the address in six 7-chars groups
                  children: (t.match(/.{1,7}/g) ?? []).map((l, d) => /* @__PURE__ */ a("span", { children: l }, d))
                }
              )
            ] }),
            /* @__PURE__ */ f("div", { className: ve, children: [
              /* @__PURE__ */ a(
                q,
                {
                  content: t,
                  label: "address",
                  showLabel: !0,
                  theme: s
                }
              ),
              /* @__PURE__ */ a(
                K,
                {
                  className: ye,
                  explorer: e,
                  showLabel: !0,
                  theme: s,
                  style: {
                    color: s.secondaryColor,
                    outlineColor: s.focusColor
                  }
                }
              )
            ] })
          ]
        }
      )
    }
  );
}
const X = U({
  avatar: null,
  name: null
});
function De() {
  return S(X);
}
function qe({
  address: t,
  children: e,
  fetchSettings: n,
  ensHooks: o
}) {
  const r = o.useEnsName?.({
    address: t,
    enabled: n.name
  }).data ?? null, s = o.useEnsAvatar?.({
    name: r || "",
    enabled: !!(n.avatar && r)
  }).data ?? null;
  return /* @__PURE__ */ a(X.Provider, { value: { avatar: s, name: r }, children: e });
}
function Fe(t) {
  const [e, n] = w(!1);
  return I(() => {
    if (n(!1), !t)
      return;
    let o = !1;
    const r = new Image();
    return r.onload = () => {
      o || n(!0);
    }, r.src = t, () => {
      o = !0;
    };
  }, [t]), e;
}
function Ge(t, e) {
  return t.length < e * 2 + 2 ? t : t.slice(0, e + 2) + "…" + t.slice(-e);
}
const Ke = Y(function({
  address: e,
  config: n
}, o) {
  const [r, s] = w(!1), c = De(), { icon: l, label: d, theme: i, shortenAddress: p } = n, g = typeof l == "function" && l(e), b = T(() => typeof g == "string" ? g : l === "ens" ? c.avatar ?? z(e) : l === "identicon" ? z(e) : typeof l == "string" ? l : null, [e, c, l, g]), m = Fe(b), u = T(() => d === "ens" && c.name ? c.name : typeof d == "function" ? d(e) : Ge(e, p || 40), [e, c, d, p]), _ = n.explorer(e), x = M(null);
  Z(
    o,
    () => x.current
  );
  const y = {
    borderRadius: i.badgeRadius,
    outlineColor: i.focusColor
  }, h = i.badgeHeight - i.badgePadding * 2, k = i.badgeBackground === "transparent" || i.badgeBackground === "none", v = i.badgeGap === 0 && !k;
  return /* @__PURE__ */ a(
    "span",
    {
      ref: x,
      className: ue,
      style: {
        position: "relative",
        display: "inline-flex",
        gap: i.badgeGap,
        maxWidth: n.maxWidth,
        height: h,
        color: i.textColor,
        padding: i.badgePadding,
        fontSize: i.fontSize
      },
      children: /* @__PURE__ */ f(ge, { ...n, children: [
        /* @__PURE__ */ f(
          "button",
          {
            className: [
              ae,
              v ? re : ""
            ].join(" "),
            onClick: () => {
              s(!0);
            },
            title: e,
            style: {
              gap: i.badgeGap,
              ...n.fontMono
            },
            children: [
              /* @__PURE__ */ a(
                "span",
                {
                  className: se,
                  style: {
                    position: "absolute",
                    opacity: v ? 1 : 0,
                    background: i.badgeBackground,
                    borderRadius: i.badgeRadius
                  }
                }
              ),
              /* @__PURE__ */ f(
                "span",
                {
                  className: le,
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: i.badgeGap,
                    ...y
                  },
                  children: [
                    g || b && /* @__PURE__ */ a(
                      "img",
                      {
                        alt: "",
                        src: m ? b : z(e),
                        width: h,
                        style: {
                          width: k ? "1.3em" : void 0,
                          borderRadius: i.badgeIconRadius ?? i.badgeRadius
                        }
                      }
                    ),
                    /* @__PURE__ */ a(
                      "span",
                      {
                        className: ce,
                        style: {
                          textTransform: n.uppercase ? "uppercase" : "none",
                          textDecoration: n.underline ? "underline" : "none",
                          background: v ? "none" : i.badgeBackground,
                          borderRadius: i.badgeRadius,
                          padding: `0 ${i.badgeLabelPadding}px`
                        },
                        children: /* @__PURE__ */ a("span", { className: de, children: u })
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        ["all", "copy"].includes(n.actions) && /* @__PURE__ */ a(
          q,
          {
            content: d === "ens" && c.name || e,
            label: d === "ens" && c.name || "address",
            theme: i,
            style: {
              width: h,
              background: v ? "none" : i.badgeBackground,
              ...y
            }
          }
        ),
        ["all", "explorer"].includes(n.actions) && /* @__PURE__ */ a(
          K,
          {
            explorer: _,
            theme: i,
            style: {
              width: h,
              background: v ? "none" : i.badgeBackground,
              ...y
            }
          }
        ),
        typeof document > "u" ? null : J(
          /* @__PURE__ */ a(
            We,
            {
              address: e,
              explorer: _,
              onClose: () => {
                s(!1);
              },
              target: x,
              show: r
            }
          ),
          n.popupNode ?? document.body
        )
      ] })
    }
  );
});
export {
  Ke as A,
  qe as E,
  j as T,
  ge as a,
  me as u
};
//# sourceMappingURL=Addreth-_1H8QZKW.js.map
